import React, { useEffect } from "react";
import { Home, Contact, WhatWeDo, About, Works, Blog, Error } from "./pages";
import { Header, Footer, Navbar, Modal } from "./components";
import { Route, Routes, useLocation, Link } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useGlobalContext } from "./context";
import localData from "./localData";

export default function App() {
    const location = useLocation();

    const { close } = localData.svgs;
    const { isModalShown, setIsModalShown, alert, setAlert } = useGlobalContext();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location.pathname]);
    return (
        <div>
            <Navbar />
            <Header />
            <Modal
                isModalShown={isModalShown}
                setIsModalShown={setIsModalShown}
                // dialogClassName="modal-dialog-scrollable"
                dialogClassName="modal-dialog-centered modal-xl subscribe-modal"
                // dialogClassName="modal-lg"
            />
            <AnimatePresence exitBeforeEnter>
                <Routes location={location} key={location.pathname}>
                     <Route path="/" element={<Home />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/what-we-do" element={<WhatWeDo />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/works" element={<Works />} />
                    <Route path="/blog" element={<Blog />} /> 

                    <Route path="*" element={<Error />} />
                </Routes>
            </AnimatePresence>
            <Footer />

            <div className={`alert alert-${alert.type} alert-popup ${alert.message ? "show" : ""}`}>
                <span className="alert-content">{alert.type == "dark" ? alert.message : "error"}</span>
                <div className="alert-closer" onClick={() => setAlert({ ...alert, message: "" })}>
                    {close}
                </div>
            </div>
        </div>
    );
}
